import { handleErrors } from "./errors";

export const formatGetCustomerQueryUrl = ({offset, limit, keyword, getGroup}) => {
    const args = [];
    const endpoint = getGroup ? 'customers/groups' : 'customers';
    keyword && args.push(`keyword=${keyword}`);
    offset > 0 && args.push(`offset=${offset}`);
    limit && args.push(`limit=${limit}`);
    return `/api/${endpoint}?${args.join('&')}`;
}

export const archiveCustomer = (customer, onError, onSuccess) => {
    if (!customer) return ; // should never happen
    fetch(`/api/customers/${customer.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: customer.id,
            archived_at: true,
        }),
    }).then(handleErrors)
        .then(data => {
            if (onSuccess) onSuccess(data);
        })
        .catch(onError);
}


export const archiveCustomers = (customers, onError, onSuccess) => {
    if (!customers || !customers.length) return ;
    fetch(`/api/customers/bulk-action`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            customer_ids: customers,
            action_type: 'archive'
        }),
    }).then(handleErrors)
        .then(data => {
            if (onSuccess) onSuccess(data);
        })
        .catch(onError);
}

export const deleteCustomerGroups = (customers, onError, onSuccess) => {
    fetch(`/api/customers/groups/bulk-delete`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
            customer_group_ids: customers
        }),
    })
        .then(handleErrors)
        .then(data => onSuccess && onSuccess(data))
        .catch(onError);
}

export const inviteCustomersToQuickPay = (customers, onError, onSuccess) => {
    if (!customers || !customers.length) return ;
    fetch(`/api/customers/bulk-action`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            customer_ids: customers,
            action_type: 'send_quickpay'
        }),
    }).then(handleErrors)
        .then(data => {
            if (onSuccess) onSuccess(data);
        })
        .catch(onError);
}

export const approveCustomer = (customer, netTerm, onError, onSuccess) => {
    if (!customer) return ; // should never happen
    fetch(`/api/customers/${customer.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: customer.id,
            application_approved_at: true,
            net_terms: netTerm || null,
        }),
    }).then(handleErrors)
        .then(data => {
            if (onSuccess) onSuccess(data);
        })
        .catch(onError);
}

export const notifyCustomer = (customer, emailDetails, onError, onSuccess) => {
    if (!customer) return ; // should never happen
    fetch(`/api/customers/${customer.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: customer.id,
            application_notified_at: true,
            ...emailDetails
        }),
    }).then(handleErrors)
        .then(data => {
            if (onSuccess) onSuccess(data);
        })
        .catch(onError);
}

export const deleteGroup = ({id, onSuccess, onError}) => {
    fetch(`/api/customers/groups/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(handleErrors)
        .then(data => {
            onSuccess && onSuccess();
        })
        .catch(() => onError && onError());
};